import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  inviteFriendsRequest,
  inviteFriendsSuccess,
  inviteFriendsFailure,
} from "./inviteActions";

import { toast } from "../../utils/helpers/toastUtils";

import { sendFacebookInvitations } from "../../services/api";

function* inviteWorker(action: ReturnType<typeof inviteFriendsRequest>) {
  try {
    const message = action.payload?.message ?? "Join me in Svara! Let’s play ";

    const { recipientIds } = action.payload as any;

    if (recipientIds?.length) {
      yield call(sendFacebookInvitations, recipientIds);
    }

    yield put(inviteFriendsSuccess({ recipientIds: recipientIds || [] }));
    toast.success(
      "Invitations sent",
      recipientIds?.length ? `${recipientIds.length} friend(s) invited` : ""
    );
  } catch (e: any) {
    const msg = e?.message || "Facebook invite failed";
    yield put(inviteFriendsFailure(msg));
    toast.error("Facebook invite failed", msg);
  }
}

export function* inviteRootSaga() {
  yield takeLatest(inviteFriendsRequest.type, inviteWorker);
}
